import React, { useEffect, useMemo, useCallback } from "react";
import { useHistory, useLocation } from "react-router";
import "./App.css";
import Routes from "./Routes";
import { Auth } from "aws-amplify";
import QNavBar from "./containers/Navigation/QNavBar";
import NavigationUpdateBanner from "./components/Navigation/NavigationUpdateBanner";
import { getNavigationVersion } from "./components/Navigation/QNavigationWrapper";
import { getAuthPageContentPaddingTop } from "./utils/authPageLayout";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { AppContext } from "./libs/appContextLib";
import axios from "axios";
import { config } from "./config";
import UnauthenticatedFooter from "./containers/UnauthenticatedFooter";
import TrialReminderSnackbar from "./containers/TrialReminder/TrialReminderSnackbar";
import LogRocket from 'logrocket';
import sortBy from 'lodash/sortBy';
import { Hub } from "@aws-amplify/core";
import { get } from "lodash";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import QPilotChatbot from "./containers/QPilotChatbot";
import TagManager from "react-gtm-module";
import { SiteMetadataDefaults } from "./components/MarketingPageMetadata";
import CookieConsent from "react-cookie-consent";
import useWindowDimensions from "./components/WindowDimensions";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import { MdInfo } from "react-icons/md";
import { Typography } from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import { format, max, parseISO, parseJSON } from "date-fns";
import Link from "@mui/material/Link";
import AnnouncementToolbar from "./components/AnnouncementToolbar";
// import { getCalApi } from "@calcom/embed-react";
import "./dsg-styles-overrides.css";
import { useQueryClient } from "@tanstack/react-query";
import apiClient, { ACTIVE_ACCOUNT_STORAGE_KEY } from "./queries/apiClient";
import { getDataStatusQueryKey, useFetchDataStatus } from "./queries/useFetchDataStatus";
import { getAvailableTablePrefSets } from "./queries/TablePrefsService";
import { RateLimitProvider } from "./contexts/RateLimitContext";
import { shouldSkipAppAuthentication } from "./utils/signupFormPersistence";
import { isTrueLike } from "./utils/booleanUtils";
import { clearDesktopLinkRedirect, getDesktopLinkRedirect } from "./utils/desktopLinkRedirect";
import { DownloadSnackbarProvider } from "./components/DownloadSnackbar";
import ColdStartCommandPalette, { ColdStartShortcutHint } from "./components/Navigation/ColdStartCommandPalette";
import { hasStoredCognitoSession } from "./utils/cognitoSessionCache";
import {normalizeForecastBucketMap} from "./libs/forecastBucketMapUtils";
import {
    getLatestTerminalBuild,
    resetTanStackForTerminalBuild,
} from "./queries/buildCacheLifecycle";
const stripePromise = loadStripe(config.STRIPE_KEY)

const getStoredAccountOverrideId = (homeCustomerId) => {
    const storedAccountId = localStorage.getItem(ACTIVE_ACCOUNT_STORAGE_KEY);

    if (!storedAccountId) {
        return null;
    }

    if (storedAccountId === homeCustomerId) {
        localStorage.removeItem(ACTIVE_ACCOUNT_STORAGE_KEY);
        return null;
    }

    return storedAccountId;
}

const App = (props) => {

    const { width } = useWindowDimensions()
    const isMobile = width <= 494

    const queryClient = useQueryClient()
    // useEffect(() => {
    //     let isInitialized = false;
    //     (async function () {
    //         if (!isInitialized) {
    //             try {
    //                 const cal = await getCalApi();
    //                 cal("ui", {
    //                     preload: true,
    //                     theme: "light",
    //                     styles: {
    //                         branding: { brandColor: "#272931" },
    //                     },
    //                 });
    //                 isInitialized = true;
    //             } catch (error) {
    //                 console.error('Failed to initialize Cal.com:', error);
    //             }
    //         }
    //     })();
    // }, []);
    
    let location = useLocation()
    let history = useHistory();

    const [drawerWidth, setDrawerWidth] = React.useState(0)
    const [qPilotDrawerWidth, setQPilotDrawerWidth] = React.useState(32)
    const [errorRequest, setErrorRequest] = React.useState(false);
    const [isAuthenticating, setIsAuthenticating] = React.useState(true);
    const [isAuthenticated, setIsAuthenticated] = React.useState(false);
    const [isHandlingAuthFailure, setIsHandlingAuthFailure] = React.useState(false);
    const [isLoggingOut, setIsLoggingOut] = React.useState(false);
    const [coldStartCommandPaletteOpen, setColdStartCommandPaletteOpen] = React.useState(false);
    const [mobileMarketingMenuOpen, setMobileMarketingMenuOpen] = React.useState(false)
    const [currUser, setCurrUser] = React.useState({});
    const [showQPilotChat, setShowQPilotChat] = React.useState(false)
    const [isQpilotFocus, setIsQpilotFocus] = React.useState(false)
    const [qPilotInitialQuestion, setQPilotInitialQuestion] = React.useState("")

    const [open, setOpen] = React.useState(localStorage.getItem("qNavBarOpen") === 'true')

    const handleErrorRequest = () => {
        setErrorRequest(!errorRequest);
    };

    const pathName = location.pathname.indexOf("/", 1) > -1 ? location.pathname.slice(0, location.pathname.indexOf("/", 1)) : location.pathname
    const onboardingStatusActive = location.pathname.startsWith('/admin/company/create')
        || location.pathname.startsWith('/admin/company/configure-data');

    const handleShowQPilotChatChange = useCallback((initialQuestion = null) => {
        console.log("handleShowQPilotChatChange", initialQuestion)
        if (showQPilotChat && (!initialQuestion || initialQuestion.length === 0)) {
            // Only close QPilot if no initial question is provided (normal close behavior)
            setShowQPilotChat(false)
            setIsQpilotFocus(false) // Reset focus mode when hiding
            setQPilotDrawerWidth(32)
            setQPilotInitialQuestion("") // Clear any initial question
        } else {
            // Either opening QPilot or QPilot is already open with a new initial question
            if (initialQuestion) {
                setQPilotInitialQuestion(initialQuestion)
            }

            if (!showQPilotChat) {
                // Only need to open QPilot if it's not already open
                requestAnimationFrame(() => {
                    setShowQPilotChat(true)
                    setQPilotDrawerWidth(isMobile ? "100%" : 390)
                })
            }

            else if (!initialQuestion && showQPilotChat)   {
                setShowQPilotChat(false)
                setIsQpilotFocus(false) // Reset focus mode when hiding
                setQPilotDrawerWidth(32)
                setQPilotInitialQuestion("") // Clear any initial question
            }
        }
    }, [showQPilotChat, isMobile]);

    const toggleQpilotFocus = useCallback(() => {
        setIsQpilotFocus(prev => !prev);
    }, []);

    const [dataStatus, setDataStatus] = React.useState([])
    const [processingStatus, setProcessingStatus] = React.useState([])
    const [fiscalQuarters, setFiscalQuarters] = React.useState([])
    const [userStatus, setUserStatus] = React.useState([])
    const [subscriptionStatus, setSubscriptionStatus] = React.useState([])
    const [dataSetupComplete, setDataSetupComplete] = React.useState(true)
    const [forecastBucketMap, setForecastBucketMap] = React.useState({})
    const [corporateCurrency, setCorporateCurrency] = React.useState("USD")
    const [corporateTimezone, setCorporateTimezone] = React.useState("")
    const [activeCrm, setActiveCrm] = React.useState("")
    const [activeAccount, setActiveAccount] = React.useState(null)
    const [availableAccounts, setAvailableAccounts] = React.useState([])
    const [canonicalArrProjectionType, setCanonicalArrProjectionType] = React.useState(null)
    const [activeAccountingPlatform, setActiveAccountingPlatform] = React.useState("")
    const [showTrialTeasers, setShowTrialTeasers] = React.useState(false)
    const [trialStatus, setTrialStatus] = React.useState({ status: "", trialingUntil: null })
    const [scenarioExistingBizModel, setScenarioExistingBizModel] = React.useState("")
    const [excludeChurnFromScenarios, setExcludeChurnFromScenarios] = React.useState(false)
    const [announcementToolbarHeight, setAnnouncementToolbarHeight] = React.useState(0)

    const resetTrialAndSubscriptionState = () => {
        setSubscriptionStatus([]);
        setTrialStatus({ status: "", trialingUntil: null });
        setShowTrialTeasers(false);
    }





    

    const isRevokedAccessTokenError = (error) => {
        return error?.code === 'NotAuthorizedException'
            || error?.message?.includes('Access Token has been revoked');
    }

    const clearLocalAuthArtifacts = () => {
        const keysToRemove = [];

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (!key) continue;

            const normalizedKey = key.toLowerCase();
            if (
                key.startsWith('CognitoIdentityServiceProvider.')
                || normalizedKey.includes('cognito')
                || normalizedKey.includes('amplify')
                || normalizedKey === 'qidentityprovider'
            ) {
                keysToRemove.push(key);
            }
        }

        keysToRemove.forEach((key) => localStorage.removeItem(key));
        localStorage.removeItem(ACTIVE_ACCOUNT_STORAGE_KEY);
        sessionStorage.clear();
    }

    useEffect(() => {
        // Don't attempt to load if we're already handling auth failure or logging out
        if (isHandlingAuthFailure || isLoggingOut) {
            return;
        }

        // Skip normal authentication logic during signup flow to prevent conflicts
        if (shouldSkipAppAuthentication(location.pathname)) {
            console.log('[App.js Auth Skip] Skipping App.js authentication logic for signup flow:', location.pathname);
            console.log('[App.js Auth Skip] Setting isAuthenticating to false to prevent loading conflicts');
            setIsAuthenticating(false);
            // Don't set isAuthenticated to false here - let signup components manage their own auth state
            return;
        }

        // Skip if already authenticated - no need to re-authenticate on every render
        if (isAuthenticated) {
            return;
        }

        // Quick check for auth tokens to avoid unnecessary auth calls
        const cognitoKeys = Object.keys(localStorage).filter(key =>
            key.startsWith('CognitoIdentityServiceProvider.')
        );

        // If no tokens at all, user is definitely not authenticated
        if (cognitoKeys.length === 0) {

            setIsAuthenticated(false);
            setCurrUser({});
            resetTrialAndSubscriptionState();
            setIsAuthenticating(false);
            return;
        }

        // Use Auth.currentSession() to validate tokens with AWS
        // This will check if tokens are valid, not expired, and not revoked

        Auth.currentSession()
            .then(session => {
                // Session is valid, tokens are good


                let isApiSubscribed = true;
                if (isApiSubscribed) {
                    let abortController = new AbortController()
                    let signal = abortController.signal
                    onLoad(signal)
                    return () => {
                        abortController.abort()
                        isApiSubscribed = false;
                    }
                }
            })
            .catch(error => {
                // Session is invalid or tokens are expired/revoked
                console.log('[Quick Auth Check] Session validation failed:', error.message || error);
                console.log('[Quick Auth Check] Clearing auth state and skipping onLoad');

                // Clear all Cognito tokens
                cognitoKeys.forEach(key => localStorage.removeItem(key));

                // Clear auth state
                setIsAuthenticated(false);
                setCurrUser({});
                setActiveAccount(null);
                setAvailableAccounts([]);
                resetTrialAndSubscriptionState();
                setIsAuthenticating(false);
                // Don't run onLoad if session is invalid
            });
    }, [isAuthenticated, isHandlingAuthFailure, isLoggingOut]) // Removed location.pathname dependency
        
    // Listen for auth failure events from apiClient
    useEffect(() => {
        const handleAuthFailed = async (event) => {
            // Prevent concurrent auth failure handling
            if (isHandlingAuthFailure) {
                
                return;
            }
            
            
            setIsHandlingAuthFailure(true);
            
            // Immediately update auth state to prevent redirect loops
            
            setIsAuthenticated(false);
            
            setIsAuthenticating(false);
            
            // Persist companyName so LoginScreen can show an auto-logout notice
            if (currUser?.companyName) {
                localStorage.setItem('qflow_auto_logout_company', currUser.companyName);
            }

            // Clear user data

            setCurrUser({});
            setActiveAccount(null);
            setAvailableAccounts([]);
            setDataStatus(null);
            resetTrialAndSubscriptionState();
            
            // Clear query cache
            try {
                await queryClient.cancelQueries();
                await queryClient.removeQueries();
                await queryClient.clear();
                
                if (queryClient.persistor) {
                    await queryClient.persistor.removeClient();
                }
            } catch (error) {
                console.error('Error clearing query cache:', error);
            }
            
            // Sign out from Amplify - handle failures gracefully
            try {
                await Auth.signOut({ global: true });
            } catch (signOutError) {
                if (isRevokedAccessTokenError(signOutError)) {
                    console.warn('[App] Auth.signOut global failed because token is already revoked. Continuing with local cleanup.');
                } else {
                    console.error('[App] Auth.signOut global failed during auth-failed handling:', signOutError);
                }

                // Best-effort local sign out in case global sign out cannot complete.
                try {
                    await Auth.signOut();
                } catch (localSignOutError) {
                    console.warn('[App] Local Auth.signOut fallback failed during auth-failed handling:', localSignOutError);
                }
            } finally {
                // Always clear local auth artifacts so stale tokens cannot silently rehydrate a session.
                clearLocalAuthArtifacts();
            }
            
            // Reset the apiClient redirect flag after a short delay
            setTimeout(() => {
                import('./queries/apiClient').then(({ resetAuthRedirectFlag }) => {
                    resetAuthRedirectFlag();
                    setIsHandlingAuthFailure(false);
                });
            }, 1000);
            
            // The AuthenticatedRoute component will handle the redirect with the proper query parameter
        };
        
        window.addEventListener('auth-failed', handleAuthFailed);
        
        return () => {
            window.removeEventListener('auth-failed', handleAuthFailed);
        };
    }, [queryClient, isHandlingAuthFailure]);

    useEffect(() => {
        open !== undefined && localStorage.setItem('qNavBarOpen', `${open}`)
    }, [open]);

    const isUsableDataStatus = (statusSnapshot) => {
        return Boolean(
            statusSnapshot &&
            typeof statusSnapshot === 'object' &&
            !Array.isArray(statusSnapshot) &&
            Object.keys(statusSnapshot).length > 0
        )
    }

    useEffect(() => {
        if (isAuthenticated) {
            if (activeCrm && isUsableDataStatus(dataStatus)) {
                checkSetupStatus(activeCrm, dataStatus);
            }
        }
    }, [dataStatus, fiscalQuarters
        , activeCrm
    ]);

    const setupLocation =
    {
        data_source_crm_initialValue: "/admin/company/create/0",
        data_source_crm_initial_data_last_capturedValue: "/admin/company/create/0",
        data_source_mktg_initialValue: "/admin/company/create/1",
        data_source_mktg_initial_data_last_capturedValue: "/admin/company/create/1",
        data_config_define_arrComplete: "/admin/company/configure-data/0",
        data_config_opp_typesComplete: "/admin/company/configure-data/1",
        data_config_opp_stagesComplete: "/admin/company/configure-data/2",
        data_config_opp_rolesComplete: "/admin/company/configure-data/3",
        data_config_program_typesComplete: "/admin/company/configure-data/4",
        data_config_prof_typesComplete: "/admin/company/configure-data/5",
    }

    const [trialAlertOpen, setTrialAlertOpen] = React.useState(false)

    const handleTrialAlertClose = e => {
        setTrialAlertOpen(!trialAlertOpen)
    }

    useEffect(() => {
        if (isAuthenticated) {
            const now = new Date()
            const nowUTC = now.getTime() / 1000
            const currentTrialEnd = parseInt(get(dataStatus, 'trial_end_date', undefined))
            const currentTrialEndDate = new Date(currentTrialEnd)
            if (currentTrialEndDate > nowUTC) {
                setTrialAlertOpen(true)
            }
        }
    }, [subscriptionStatus])

    useEffect(() => {
        Hub.listen("auth", ({ payload: { event, data } }) => {
            switch (event) {
                case "signIn":
                    onLoad().then(result => {
                    })
                    break;
                case "cognitoHostedUI":
                    break;
                case "signOut":
                    break;
                case "signIn_failure":
                case "cognitoHostedUI_failure":
                    console.log("Sign in failure", data);
                    setErrorRequest(data)
                    break;
            }
        });
    }, []);

    const checkSetupStatus = (activeCrmLocal, statusSnapshot = dataStatus) => {
        if (!isUsableDataStatus(statusSnapshot)) {
            return
        }

        const activeCrmToCheck = activeCrmLocal ? activeCrmLocal : activeCrm
        const data_source_sfdc_initialValue = get(statusSnapshot, 'processing_status.status_data_source.sfdc.completed', null)
        const data_source_sfdc_initial_data_last_capturedValue = get(statusSnapshot, 'processing_status.status_data_ingest.sfdc_initial_data.completed', null)
        const data_source_hscrm_initialValue = get(statusSnapshot, 'processing_status.status_data_source.hscrm.completed', null)
        const data_source_hscrm_initial_data_last_capturedValue = get(statusSnapshot, 'processing_status.status_data_ingest.hscrm_initial_data.completed', null)
        let dataSourceCrmInitialValue = activeCrmToCheck === "hscrm" ? data_source_hscrm_initialValue : data_source_sfdc_initialValue
        let dataSourceCrmLastCaptured = activeCrmToCheck === "hscrm" ? data_source_hscrm_initial_data_last_capturedValue : data_source_sfdc_initial_data_last_capturedValue

        const data_source_mktg_initialValue = get(statusSnapshot, 'processing_status.status_data_source.mktg_initial_data.completed', null)
        const data_source_mktg_initial_data_last_capturedValue = get(statusSnapshot, 'processing_status.status_data_ingest.mktg_initial_data.completed', null)
        const data_config_define_arrComplete = get(statusSnapshot, 'processing_status.status_data_config.define_arr.complete', null)
        const data_config_opp_typesComplete = get(statusSnapshot, 'processing_status.status_data_config.opp_types.complete', null)
        const data_config_opp_stagesComplete = get(statusSnapshot, 'processing_status.status_data_config.opp_stages.complete', null)
        const data_config_opp_rolesComplete = get(statusSnapshot, 'processing_status.status_data_config.opp_roles.complete', null)
        const data_config_program_typesComplete = get(statusSnapshot, 'processing_status.status_data_config.program_types.complete', null)

        const data_config_prof_typesComplete = get(statusSnapshot, 'processing_status.status_data_config.prof_types.complete', null)
        if (statusSnapshot) {
            if (dataSourceCrmInitialValue === null ||
                dataSourceCrmLastCaptured === null ||
                data_config_define_arrComplete === null ||
                data_config_opp_typesComplete === null ||
                data_config_opp_stagesComplete === null ||
                data_config_opp_rolesComplete === null ||
                data_config_program_typesComplete === null ||
                data_config_prof_typesComplete === null
            ) {
                setDataSetupComplete(false)
            } else {
                setDataSetupComplete(true)
            }
            if (
                (!location.search || location.search.length === 0) &&
                !getDesktopLinkRedirect() &&
                !isAuthenticating &&
                isAuthenticated
                && location.pathname.slice(0, 6) !== "/admin"
                && location.pathname.slice(0, 8) !== "/company"
                && location.pathname !== "/settings"
                && location.pathname !== "/contact-us"
                && location.pathname.slice(0, 4) !== "/faq"
                && location.pathname !== "/service-terms"
            ) {
                if (currUser.role === 'admin_user' && activeCrmToCheck) {
                    if (dataSourceCrmInitialValue === null) {
                        history.push(setupLocation['data_source_crm_initialValue'])
                    } else if (dataSourceCrmLastCaptured === null) {
                        history.push(setupLocation['data_source_crm_initial_data_last_capturedValue'])
                    } else if (data_config_define_arrComplete === null) {
                        history.push(setupLocation['data_config_define_arrComplete'])
                    }
                    else if (data_config_opp_stagesComplete === null) {
                        history.push(setupLocation['data_config_opp_stagesComplete'])
                    } else if (data_config_opp_rolesComplete === null) {
                        history.push(setupLocation['data_config_opp_rolesComplete'])
                    } else if (data_config_prof_typesComplete === null) {
                        history.push(setupLocation['data_config_prof_typesComplete'])
                    }
                }
            }
        }
    }


    const {
        status: dataStatusFetchingStatus,
        data: dataStatusNew,
    } = useFetchDataStatus(
        isAuthenticated,
        currUser.id,
        currUser.customerId,
        {onboardingActive: onboardingStatusActive},
    )

    const prefetchQueries = () => {
        if (!isAuthenticated) return;

        queryClient.prefetchQuery({
            queryKey: [`${currUser.customerId}_existing-scenarios`],
            queryFn: async () => {
                const response = await apiClient.get(`${config.REACT_APP_BACKEND_HOST}/scenarios`, {});
                return response.data
            },
            staleTime: 1000 * 60 * 60 * 36,
            gcTime: 1000 * 60 * 60 * 36,
        });

        return queryClient.prefetchQuery({
            queryKey: [`${currUser.customerId}_table-pref-sets`],
            queryFn: getAvailableTablePrefSets,
        });
    }

    useEffect(() => {
        currUser && Object.keys(currUser).length > 0 && prefetchQueries()
    }, [currUser])

    useEffect(() => {
        const hasFreshDataStatus = (
            dataStatusFetchingStatus === 'success' &&
            dataStatusNew &&
            Object.keys(dataStatusNew).length > 0 &&
            isUsableDataStatus(dataStatusNew.dataStatus)
        )

        if (hasFreshDataStatus) {
            setDataStatus({
                ...dataStatusNew.dataStatus,
                model_trained: dataStatusNew.model_trained,
                deal_evaluations: dataStatusNew.deal_evaluations
            })
            setProcessingStatus(dataStatusNew.dataStatus?.processing_status_new || [])
            setCanonicalArrProjectionType(dataStatusNew.canonical_arr_projection_type)
            setForecastBucketMap(normalizeForecastBucketMap(dataStatusNew.forecastBucketMap))
        }
    }, [dataStatusNew, dataStatusFetchingStatus])

    useEffect(() => {
        if (!isAuthenticated || !currUser?.id || !currUser?.customerId) return;

        const terminalBuild = getLatestTerminalBuild(
            dataStatusNew?.dataStatus?.processing_status_new
        );
        if (!terminalBuild) return;

        resetTanStackForTerminalBuild({
            queryClient,
            userId: currUser.id,
            customerId: currUser.customerId,
            terminalBuild,
        }).catch(error => {
            console.error('[App] Failed to refresh cache after terminal build:', error);
        });
    }, [
        currUser?.customerId,
        currUser?.id,
        dataStatusNew?.dataStatus?.processing_status_new,
        isAuthenticated,
        queryClient,
    ])

    const getUserPreferenceDateRangeOptions = () => {
        const dateRangeAsDefault = window.localStorage.getItem(`${currUser.customerId}_dateRangeOptions`)

        return dateRangeAsDefault ? JSON.parse(dateRangeAsDefault) : undefined
    }

    const userPreferenceDateRangeOptions = getUserPreferenceDateRangeOptions()



    const onLoad = async (signal) => {
        try {
            await Promise.all([
                await Auth.currentSession(),
                await Auth.currentAuthenticatedUser()
                    .then(authenticatedUser => {
                        const emailVerifiedStatus = get(authenticatedUser, 'attributes.email_verified', false)
                        const homeCustomerId = authenticatedUser.attributes["custom:qflowCustomerId"];
                        const storedAccountOverrideId = getStoredAccountOverrideId(homeCustomerId);
                        const selectedAccountId = storedAccountOverrideId || homeCustomerId;
                        let currentUserToSet = {
                            authToken: authenticatedUser.signInUserSession.idToken.jwtToken,
                            accessToken: authenticatedUser.signInUserSession.accessToken.jwtToken,
                            id: authenticatedUser.attributes.sub,
                            role: authenticatedUser.attributes["custom:currentUserRole"],
                            firstName: authenticatedUser.attributes["given_name"],
                            lastName: authenticatedUser.attributes["family_name"],
                            email: authenticatedUser.attributes["email"],
                            emailVerified: emailVerifiedStatus ? emailVerifiedStatus : false,
                            phone: authenticatedUser.attributes["phone"] ? authenticatedUser.attributes["phone"] : null,
                            companyName: authenticatedUser.attributes["custom:companyName"],
                            homeCustomerId,
                            customerId: selectedAccountId,
                            sfdcUrl: authenticatedUser.attributes["custom:companySalesforceUrl"] ? authenticatedUser.attributes["custom:companySalesforceUrl"] : 'https://login.salesforce.com',
                            authPref: authenticatedUser.attributes["custom:auth_preference"] ? authenticatedUser.attributes["custom:auth_preference"] : "built-in",
                        }
                        resetTrialAndSubscriptionState();
                        // Set currUser early to provide essential fields (role, customerId, etc.) to components
                        // This prevents "Cannot read properties of undefined" errors in 600+ places that access currUser.role
                        // Will be updated again after API call with additional fields (sfdcUrl from backend, accessPermissions)
                        setCurrUser(currentUserToSet)

                        // Don't let regular users access test instance.
                        if (process.env.REACT_APP_STAGE === 'dev'
                            && authenticatedUser.attributes["custom:qflowCustomerId"] !== "2a2b4a38-4635-47d4-9a36-3736a1d051c5"
                            && !(currentUserToSet.email.indexOf('greenwald') > -1
                                || currentUserToSet.email.indexOf('qflow') > -1)) {
                            setIsAuthenticated(false);
                            queryClient.invalidateQueries()
                            Auth.signOut({global: true}).catch(err => {
                                console.log('Auth.signOut failed (test instance check):', err);
                            })
                        } else if (emailVerifiedStatus) {
                            // console.log('[onLoad] Setting isAuthenticated to true, email verified');
                            // setIsAuthenticated(true);
                            setDrawerWidth(240)
                            const dataStatusHeaders = {
                                Authorization: currentUserToSet.authToken,
                            };
                            if (storedAccountOverrideId) {
                                dataStatusHeaders['X-QFlow-Account-Id'] = storedAccountOverrideId;
                            }

                            axios.get(`${config.REACT_APP_BACKEND_HOST}/configure/data/status`, {
                                headers: dataStatusHeaders,
                                signal: signal,
                                params: {}
                            }).then(response => {
                                const activeAccountFromApi = response.data?.activeAccount || {
                                    customerId: selectedAccountId,
                                    companyName: currentUserToSet.companyName,
                                    accountType: 'entity',
                                };
                                const availableAccountsFromApi = response.data?.availableAccounts || [activeAccountFromApi];
                                if (storedAccountOverrideId && activeAccountFromApi.accountType === 'rollup') {
                                    localStorage.removeItem(ACTIVE_ACCOUNT_STORAGE_KEY);
                                    setCurrUser({ ...currentUserToSet, customerId: homeCustomerId });
                                    onLoad(signal);
                                    return;
                                }
                                const activeCustomerId = activeAccountFromApi.customerId || selectedAccountId;
                                queryClient.setQueryData(
                                    getDataStatusQueryKey(currentUserToSet.id, activeCustomerId),
                                    response.data
                                )
                                if (availableAccountsFromApi.length > 1 && activeCustomerId !== homeCustomerId) {
                                    localStorage.setItem(ACTIVE_ACCOUNT_STORAGE_KEY, activeCustomerId);
                                } else {
                                    localStorage.removeItem(ACTIVE_ACCOUNT_STORAGE_KEY);
                                }

                                // Extract user permissions from userStatus (fallback to permissive defaults)
                                const permissionsFromApi = response.data?.userStatus?.accessPermissions || {};
                                const isInternalQflowUser = currentUserToSet.email?.toLowerCase().includes("@qflow.ai");
                                const userPermissions = {
                                    read: {
                                        forecast: permissionsFromApi?.read?.forecast || "master",
                                        expense: isInternalQflowUser
                                            ? "full"
                                            : (permissionsFromApi?.read?.expense || "full"),
                                    },
                                    write: permissionsFromApi?.write || {},
                                };

                                const currentUserToSetWithCrmUrl = {
                                    ...currentUserToSet,
                                    customerId: activeCustomerId,
                                    homeCustomerId,
                                    companyName: activeAccountFromApi.companyName || currentUserToSet.companyName,
                                    sfdcUrl: response.data.dataStatus.sfdcUrl,
                                    accessPermissions: userPermissions,
                                    userId: response.data.userStatus?.id,
                                }

                                const excludeDataGenTrialEnded = isTrueLike(get(response.data, "subscriptionStatus.exclude_data_gen", false));
                                if (
                                    excludeDataGenTrialEnded
                                    && !getDesktopLinkRedirect()
                                    && authenticatedUser.attributes["custom:qflowCustomerId"] !== "2a2b4a38-4635-47d4-9a36-3736a1d051c5"
                                ) {
                                    location.pathname.slice(0, 6) !== "/admin"
                                        && location.pathname.slice(0, 8) !== "/company"
                                        && location.pathname !== "/settings"
                                        && location.pathname !== "/contact-us"
                                        && location.pathname.slice(0, 4) !== "/faq"
                                        && location.pathname !== "/service-terms" && location.pathname.slice(0, 14) !== "/admin/billing"
                                        && history.push('/trial-ended')
                                }

                                const shouldShowTrialTeasers = isTrueLike(get(response.data, "subscriptionStatus.show_trial_teasers", false));
                                if (shouldShowTrialTeasers) {
                                    setShowTrialTeasers(true)
                                }
                            
                                const trialEndDateToSet = get(response.data, "subscriptionStatus.trial_end_date", null)
                                const startSubscriptionStart = get(response.data, "subscriptionStatus.stripe_subscription.stripe_subscription_created", null)
                                if (trialEndDateToSet) {
                                    const didUpgrade = startSubscriptionStart?.length > 0
                                    setTrialStatus({
                                        status: didUpgrade || shouldShowTrialTeasers ? "trial_ended" :
                                            !get(response.data, "subscriptionStatus.trial_end_date", null) ? "not_trialing" : "trialing",
                                        trialingUntil: trialEndDateToSet
                                    })
                                }

                                setCurrUser(currentUserToSetWithCrmUrl)
                                setActiveAccount(activeAccountFromApi)
                                setAvailableAccounts(availableAccountsFromApi)
                                setActiveCrm(response.data.crm)
                                setActiveAccountingPlatform(response.data["accounting_platform"])
                                response.data['functional_currency'] && setCorporateCurrency(response.data['functional_currency'])
                                setCorporateTimezone(response.data['corporate_tz'])
                                response.data['scenario_existing_biz_model'] && setScenarioExistingBizModel(response.data['scenario_existing_biz_model'])
                                // Default to false (opt-in to churn) if not present
                                setExcludeChurnFromScenarios(response.data['exclude_churn_from_scenarios'] ?? false)
                                setDataStatus(response.data.dataStatus)
                                setCanonicalArrProjectionType(response.data.canonical_arr_projection_type)
                                setProcessingStatus(response.data.dataStatus['processing_status_new'])

                                let fiscalQuartersToSet = response.data['fiscalQuarters']
                                let fiscalQuartersSorted = sortBy(fiscalQuartersToSet, o => o['StartDate'])
                                localStorage.setItem(`${activeCustomerId}-fiscalQuartersLocal`, JSON.stringify(fiscalQuartersSorted))
                                setFiscalQuarters(fiscalQuartersSorted)
                                setForecastBucketMap(normalizeForecastBucketMap(response.data['forecastBucketMap']))
                                setUserStatus(response.data['userStatus'])
                                setSubscriptionStatus(response.data.subscriptionStatus || [])
                                setIsAuthenticated(true);
                                setIsAuthenticating(false);
                    
                            })
                                .catch(async (error) => {
                                    setIsAuthenticating(false);
                                    if (axios.isCancel(error)) {
                                    } else {
                                        if (storedAccountOverrideId && !error.response) {
                                            localStorage.removeItem(ACTIVE_ACCOUNT_STORAGE_KEY);
                                            setCurrUser({ ...currentUserToSet, customerId: homeCustomerId });
                                            onLoad(signal);
                                            return;
                                        }

                                        if (error.response && error.response.status && error.response.status === 403) {
                                            if (storedAccountOverrideId) {
                                                localStorage.removeItem(ACTIVE_ACCOUNT_STORAGE_KEY);
                                                setCurrUser({ ...currentUserToSet, customerId: homeCustomerId });
                                                onLoad(signal);
                                                return;
                                            }
                                            console.log("Session has expired.")
                                            setIsAuthenticated(false);
                                            setIsAuthenticating(false);
                                            // Persist companyName so LoginScreen can show an auto-logout notice
                                            if (currentUserToSet?.companyName) {
                                                localStorage.setItem('qflow_auto_logout_company', currentUserToSet.companyName);
                                            }
                                            setCurrUser({}); // Clear user data immediately
                                            setActiveAccount(null);
                                            setAvailableAccounts([]);
                                            resetTrialAndSubscriptionState();
                                            console.log("[onLoad 403] Clearing currUser");
                                            Auth.signOut({global: true}).catch(err => {
                                             console.log('Auth.signOut failed (403 response):', err);
                                            });

                                            try {
                                                await queryClient.cancelQueries()
                                                await queryClient.removeQueries()
                                                await queryClient.clear()
                                                if (queryClient.persistor) {
                                                    await queryClient.persistor.removeClient()
                                                }
                                            } catch (cacheError) {
                                                console.error('[App] Error clearing cache on 403:', cacheError);
                                            }

                                            console.log("Access is denied - logging out")
                                        }
                                        
                                        if (error.response?.data?.error === "Access denied") {
                                            setIsAuthenticated(false)
                                            setIsAuthenticating(false);
                                            setCurrUser({}); // Clear user data immediately
                                            setActiveAccount(null);
                                            setAvailableAccounts([]);
                                            resetTrialAndSubscriptionState();
                                            console.log("[onLoad Access denied] Clearing currUser");
                                        }
                                        if (error.response) {
                                            console.log(error.response.data);
                                            console.log(error.response.status);
                                            console.log(error.response.headers);
                                        } else if (error.request) {
                                            console.log("error request", error.request);
                                            handleErrorRequest();
                                        } else {
                                            console.log('Error', error.message);
                                            setErrorRequest(false);
                                        }
                                    }
                                });
                        }
                    }
                    )
            ])

        } catch (e) {
            // Handle auth errors gracefully
            if (e.code === 'NotAuthorizedException' || e.message?.includes('Access Token has been revoked')) {
                
                
                // Dispatch auth-failed event to centralize handling
                window.dispatchEvent(new CustomEvent('auth-failed', { 
                    detail: { 
                        reason: 'token_revoked_onload',
                        message: e.message 
                    }
                }));
                
                setIsAuthenticating(false);
                return; // Exit early, don't rethrow
            }
            
            // For other errors, log but don't crash
            console.error('Error in onLoad:', e);
        }
        // console.log('[onLoad] Setting isAuthenticating to false at end of function');
        // setIsAuthenticating(false);
    }

    // Perform a hard reset of the React Query cache and persisted storage
    const hardResetQueryCache = async () => {
        try {
            await queryClient.cancelQueries();
            await queryClient.removeQueries();
            await queryClient.clear();
            if (queryClient.persistor) {
                await queryClient.persistor.removeClient();
            }
        } catch (error) {
            console.error('Error during hard query cache reset:', error);
        }
    }

    const handleAccountSwitch = useCallback(async (customerId) => {
        if (!customerId || customerId === currUser?.customerId) return;

        const nextAccount = availableAccounts.find((account) => account.customerId === customerId);
        if (nextAccount?.accountType === 'rollup') {
            console.warn('[App] Ignoring global account switch to rollup account. Rollups are scoped to the Scenarios view.');
            return;
        }

        if (customerId === currUser?.homeCustomerId) {
            localStorage.removeItem(ACTIVE_ACCOUNT_STORAGE_KEY);
        } else {
            localStorage.setItem(ACTIVE_ACCOUNT_STORAGE_KEY, customerId);
        }
        if (nextAccount) {
            setActiveAccount(nextAccount);
        }
        setCurrUser((prev) => ({ ...prev, customerId }));
        setDataStatus(null);
        setProcessingStatus([]);
        resetTrialAndSubscriptionState();

        try {
            await hardResetQueryCache();
            await onLoad();
        } catch (error) {
            console.error('[App] Error switching active account:', error);
            setIsAuthenticating(false);
        }
    }, [availableAccounts, currUser?.customerId, currUser?.homeCustomerId]);

    useEffect(() => {
        if (location.pathname === "/desktop/auth-complete") {
            clearDesktopLinkRedirect();
        }
    }, [location.pathname]);

    useEffect(() => {
        // Patch ResizeObserver to prevent errors
        const resizeObserverErrorHandler = () => {
            const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
            const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
            if (resizeObserverErr) {
                resizeObserverErr.style.display = 'none';
            }
            if (resizeObserverErrDiv) {
                resizeObserverErrDiv.style.display = 'none';
            }
        };
        
        // Monkey patch ResizeObserver to add error handling
        if (window.ResizeObserver) {
            const OriginalResizeObserver = window.ResizeObserver;
            window.ResizeObserver = class extends OriginalResizeObserver {
                constructor(callback) {
                    const wrappedCallback = (entries, observer) => {
                        try {
                            callback(entries, observer);
                        } catch (e) {
                            if (!e?.message?.includes('ResizeObserver')) {
                                throw e;
                            }
                        }
                    };
                    super(wrappedCallback);
                }
            };
        }
        
        window.addEventListener('error', resizeObserverErrorHandler);
        
        console.log(" $$$$$$\\   $$$$$$\\  $$\\                                      $$\\ \n" +
            "$$  __$$\\ $$  __$$\\ $$ |                                     \\__|\n" +
            "$$ /  $$ |$$ /  \\__|$$ | $$$$$$\\  $$\\  $$\\  $$\\     $$$$$$\\  $$\\ \n" +
            "$$ |  $$ |$$$$\\     $$ |$$  __$$\\ $$ | $$ | $$ |    \\____$$\\ $$ |\n" +
            "$$ |  $$ |$$  _|    $$ |$$ /  $$ |$$ | $$ | $$ |    $$$$$$$ |$$ |\n" +
            "$$ $$\\$$ |$$ |      $$ |$$ |  $$ |$$ | $$ | $$ |   $$  __$$ |$$ |\n" +
            "\\$$$$$$ / $$ |      $$ |\\$$$$$$  |\\$$$$$\\$$$$  |$$\\\\$$$$$$$ |$$ |\n" +
            " \\___$$$\\ \\__|      \\__| \\______/  \\_____\\____/ \\__|\\_______|\\__|\n" +
            "     \\___|                                                       \n" +
            "                                                                 \n" +
            " We're hiring ML/AI experts and software engineers at qflow.ai ")
            
        // Handle ResizeObserver errors globally
        const handleResizeObserverError = (e) => {
            if (e?.message === 'ResizeObserver loop completed with undelivered notifications.' || 
                e?.message?.includes('ResizeObserver loop') ||
                e?.message?.includes('ResizeObserver loop limit exceeded')) {
                // Suppress this benign error - it's a known issue with ResizeObserver and Victory.js charts
                e?.preventDefault()
                e?.stopImmediatePropagation()
                e?.stopPropagation()
                return false
            }
        }
        
        // Also handle uncaught errors that don't trigger the error event
        const originalConsoleError = console.error
        console.error = (...args) => {
            const errorMsg = args.join(' ')
            if (errorMsg.includes('ResizeObserver loop completed with undelivered notifications')) {
                // Suppress ResizeObserver errors in console
                return
            }
            originalConsoleError.apply(console, args)
        }
        
        const handleUnhandledRejection = (e) => {
            if (e.reason?.message?.includes('ResizeObserver loop') || 
                e.reason?.message?.includes('ResizeObserver loop completed with undelivered notifications')) {
                e.preventDefault()
                e.stopImmediatePropagation()
                return false
            }
        }
        
        // Add error handler with capture phase to catch errors earlier
        window.addEventListener('error', handleResizeObserverError, true)
        window.addEventListener('unhandledrejection', handleUnhandledRejection, true)
        
        return () => {
            window.removeEventListener('error', handleResizeObserverError, true)
            window.removeEventListener('unhandledrejection', handleUnhandledRejection, true)
            window.removeEventListener('error', resizeObserverErrorHandler)
            // Restore original console.error
            console.error = originalConsoleError
        }
    }, [])

    const handleClickedLogout = async (event) => {
        // Set logging out state to prevent re-renders during logout process
        setIsLoggingOut(true);

        window.localStorage.setItem(`${currUser.customerId}_active-gtm-stat-segments`, JSON.stringify(["default"]))

        try {
            // Clear query cache
            await queryClient.cancelQueries()
            await queryClient.removeQueries()
            await queryClient.clear()

            if (queryClient.persistor) {
                await queryClient.persistor.removeClient()
            }
        } catch (error) {
            console.error('[App] Error clearing cache during logout:', error);
        }

        // Notify backend about auth change (non-blocking)
        apiClient.post(`${config.REACT_APP_BACKEND_HOST}/auth-change`, {}, {})
            .catch(error => {
                console.warn('[App] Failed to notify backend of auth change:', error);
            });

        const companyNameForLogoutNotice = currUser?.companyName;

        try {
            // Sign out from Amplify
            await Auth.signOut({ global: true });
        } catch (error) {
            // If token is already revoked, treat this as logged out and continue cleanup.
            if (isRevokedAccessTokenError(error)) {
                console.warn('[App] Auth.signOut global failed because token is already revoked. Treating logout as successful.');
            } else {
                console.error('[App] Auth.signOut failed during logout:', error);
            }

            // Best-effort local sign out in case global sign out cannot complete.
            try {
                await Auth.signOut();
            } catch (localSignOutError) {
                console.warn('[App] Local Auth.signOut fallback failed during logout:', localSignOutError);
            }
        } finally {
            // Always clear local auth artifacts to prevent silent re-authentication after redirect.
            clearLocalAuthArtifacts();

            setCurrUser({});
            setActiveAccount(null);
            setAvailableAccounts([]);
            setDataStatus(null);
            resetTrialAndSubscriptionState();
            setIsAuthenticated(false);
            setDrawerWidth(0);

            if (companyNameForLogoutNotice) {
                localStorage.setItem('qflow_auto_logout_company', companyNameForLogoutNotice);
            }
            history.push('/login');

            // Reset logging out state
            setIsLoggingOut(false);
        }
    }

    const checkDataStatusToInvalidateCache = () => {
        if (dataStatus && Object.keys(dataStatus).length > 0) {
            const lastStreamingUpdate = dataStatus['last_streaming_update'] ? parseISO(dataStatus['last_streaming_update']) : null
            const processingStatus = dataStatus['processing_status_new']
            const isDataStatusQuery = (queryKey) => {
                if (!queryKey) return false
                if (Array.isArray(queryKey)) return queryKey[0] === 'data-status'
                return queryKey === 'data-status'
            }

            if (!Array.isArray(processingStatus)) {
                return
            }

            const processingStatusesOfInterest = processingStatus.filter(filterItem => filterItem.statusEntry === "1_core_generator" || filterItem.statusEntry === "5_response_generator" || filterItem.statusEntry === "6_on_hand_predictor_preprocess" ||
                filterItem.statusEntry === "last_streaming_update" || filterItem.statusEntry === "4_task_generator" || filterItem.statusEntry === "7_opportunity_source_generator")

            const processingStatusCompletionTimes = processingStatusesOfInterest.filter(filterItem => filterItem.status.completed).map(item => parseISO(item.status.completed))

            const maxUpdate = max([...processingStatusCompletionTimes, lastStreamingUpdate].filter(item => typeof item === "object"))

            // If we cannot determine a valid update time, skip invalidation safely
            if (!maxUpdate) {
                return
            }

            const queries = queryClient.getQueryCache().getAll();

            const queryInfoList = queries.map((query) => {
                const queryKey = query.queryKey;
                const lastFetched = new Date(query.state.dataUpdatedAt);
                return {
                    queryKey,
                    lastFetched,
                };
            });

            const queriesToInvalidate = queryInfoList.filter(filterItem => {
                // Never invalidate `data-status` from this pass; doing so causes a self-refetch loop.
                if (isDataStatusQuery(filterItem.queryKey)) {
                    return false
                }

                return filterItem.lastFetched && filterItem.lastFetched <= maxUpdate
            })

            const queryKeysToInvalidate = queriesToInvalidate && queriesToInvalidate.length > 0 && queriesToInvalidate.map(item => item.queryKey)

            if (queryKeysToInvalidate && queryKeysToInvalidate.length > 0) {
                queryKeysToInvalidate.forEach((queryKey) => {
                    queryClient.invalidateQueries({ queryKey }, { refetchType: 'all' })
                });
            }
        }
    }

    useEffect(() => {
        checkDataStatusToInvalidateCache()
    }, [dataStatus])

    const theme = useTheme();

    function handleDrawerToggle(e) {
        e.preventDefault()
        try {
            if (open === false) {
                setOpen(true)
                setDrawerWidth(width < 900 && !isMobile ? 72 : 240)
                open !== undefined && localStorage.setItem("qNavBarOpen", !open)
            } else {
                setOpen(false)
                setDrawerWidth(width < 900 && !isMobile ? 72 : 0)
                open !== undefined && localStorage.setItem("qNavBarOpen", !open)
            }
        } catch (e) {
        }
    }

    const [mobileMarketingAnchorEl, setMobileMarketingAnchorEl] = React.useState(null)

    function handleMobileMarketingDrawerToggle(e) {
        e?.preventDefault()
        if (mobileMarketingMenuOpen === false) {
            setMobileMarketingMenuOpen(true)
            setDrawerWidth(288)
        } else {
            setMobileMarketingMenuOpen(false)
            setDrawerWidth(72)
        }
    }

    const tagManagerArgs = {
        dataLayer: {
            userId: currUser.id,
            userProject: currUser.companyName,
        },
        dataLayerName: 'QDataLayer'
    }

    useEffect(() => {

        process.env.REACT_APP_STAGE !== "dev" && currUser && currUser.email && TagManager.dataLayer(tagManagerArgs)
        // && currUser.email.indexOf('qflow.ai') === -1

        process.env.REACT_APP_STAGE !== "dev" && currUser && currUser.email && currUser.email.indexOf('qflow.ai') === -1 && LogRocket.init('6uvm9i/qflow')

        process.env.REACT_APP_STAGE !== "dev" && currUser && currUser.email && currUser.email.indexOf('qflow.ai') === -1 &&


            LogRocket.identify(currUser.id, {
                name: currUser.firstName + " " + currUser.lastName,
                email: currUser.email,
                // Add your own custom user variables here, ie:
                subscriptionType: subscriptionStatus
            });
    }, [currUser])

    const locationPath = location.pathname;

    const [upcomingMaintenance, setUpcomingMaintenance] = React.useState()

    async function getUpcomingMaintenanceFromServiceStatusPage() {
        axios.get(`https://status.qflow.ai/api/v2/scheduled-maintenances/upcoming.json`, {}).then(response => {
            setUpcomingMaintenance(response.data)
        }).catch(error => console.log(`there was an error fetching users: ${error}`))
    }

    useEffect(() => {
        !upcomingMaintenance && getUpcomingMaintenanceFromServiceStatusPage()
    }, [])

    const acceptedBookingMetric = dataStatus && dataStatus['booking_metric']
    const forecastPeriodPreference = dataStatus && dataStatus['forecast_period_preference']  ? dataStatus['forecast_period_preference'] : "quarterly"
    const acceptedBookingMetricString = acceptedBookingMetric === "amount_field" || acceptedBookingMetric === "tcv_field" ? "Amount" : "ARR";

    // Memoize the AppContext value to prevent unnecessary re-renders
    // MUST be called at top level before any conditional returns
    // Only include values that actually change during auth flow - not setter functions
    const appContextValue = useMemo(() => ({
        handleShowQPilotChatChange,
        userPreferenceDateRangeOptions,
        setDrawerWidth,
        processingStatus,
        qPilotDrawerWidth,
        currUser,
        isAuthenticated,
        corporateCurrency,
        corporateTimezone,
        activeCrm,
        activeAccount,
        availableAccounts,
        handleAccountSwitch,
        activeAccountingPlatform,
        forecastPeriodPreference,
        acceptedBookingMetricString,
        dataStatus,
        canonicalArrProjectionType,
        fiscalQuarters,
        forecastBucketMap,
        userStatus,
        subscriptionStatus,
        showTrialTeasers,
        trialStatus,
        scenarioExistingBizModel,
        excludeChurnFromScenarios,
        setIsAuthenticated,
        setDataStatus,
        setSubscriptionStatus,
        onLoad,
        dataSetupComplete,
        drawerWidth,
        coldStartCommandPaletteOpen
    }), [
        // Only include primitive values and objects that change during auth
        // Exclude setter functions as they have stable references
        handleShowQPilotChatChange,
        qPilotDrawerWidth,
        isAuthenticated,
        corporateCurrency,
        corporateTimezone,
        activeCrm,
        handleAccountSwitch,
        activeAccountingPlatform,
        forecastPeriodPreference,
        acceptedBookingMetricString,
        canonicalArrProjectionType,
        showTrialTeasers,
        scenarioExistingBizModel,
        excludeChurnFromScenarios,
        dataSetupComplete,
        drawerWidth,
        coldStartCommandPaletteOpen,
        // Use JSON.stringify for complex objects to prevent reference changes
        JSON.stringify(currUser),
        JSON.stringify(activeAccount),
        JSON.stringify(availableAccounts),
        JSON.stringify(processingStatus),
        JSON.stringify(fiscalQuarters),
        JSON.stringify(forecastBucketMap),
        JSON.stringify(userStatus),
        JSON.stringify(subscriptionStatus),
        JSON.stringify(trialStatus),
        JSON.stringify(dataStatus)
    ]);

    const hasStoredSession = hasStoredCognitoSession();

    return (
        <React.Fragment>
            <AppContext.Provider value={appContextValue}>
                <ColdStartCommandPalette
                    isAuthenticating={isAuthenticating}
                    isAuthenticated={isAuthenticated}
                    isLoggingOut={isLoggingOut}
                    hasStoredSession={hasStoredSession}
                    open={coldStartCommandPaletteOpen}
                    onOpen={() => setColdStartCommandPaletteOpen(true)}
                    onClose={() => setColdStartCommandPaletteOpen(false)}
                />
            </AppContext.Provider>

            {!isAuthenticating && !isLoggingOut
            ?
            <Elements stripe={stripePromise}>
                <Box sx={{ backgroundColor: "background.default" }}>
                    <SiteMetadataDefaults />

                    <RateLimitProvider>
                        <DownloadSnackbarProvider>
                        <AppContext.Provider value={appContextValue}>

                        <AnnouncementToolbar
                            isAuthenticated={isAuthenticated}
                            onHeightChange={setAnnouncementToolbarHeight}
                        />

                        {pathName &&
                            <QNavBar 
                                isLoggedIn={isAuthenticated}
                                handleMobileMarketingDrawerToggle={handleMobileMarketingDrawerToggle}
                                pathName={pathName}
                                handleClickedLogout={handleClickedLogout}
                                drawerWidth={drawerWidth}
                                handleDrawerToggle={handleDrawerToggle}
                                open={open}
                                setOpen={setOpen}
                                mobileMarketingMenuOpen={mobileMarketingMenuOpen}
                                currUser={currUser}
                                announcementToolbarHeight={announcementToolbarHeight}
                                showQPilotChat={showQPilotChat}
                                isMobile={isMobile}
                                isQpilotFocus={isQpilotFocus}
                                handleShowQPilotChatChange={handleShowQPilotChatChange}
                            />
                        }

                        <Box
                            sx={{
                                flexGrow: 1,
                                paddingTop: `${getAuthPageContentPaddingTop({
                                    isMobile,
                                    isAuthenticated,
                                    pathName,
                                    announcementToolbarHeight,
                                })}px`,
                                marginRight: !isAuthenticated ? 0 : 
                                    isMobile && showQPilotChat ? "0px" : 
                                    isMobile && !showQPilotChat ?  `32px`:
                                    typeof qPilotDrawerWidth === 'string' ? qPilotDrawerWidth : `${qPilotDrawerWidth}px`,
                                transition: theme.transitions.create(['margin', 'paddingTop'], {
                                    easing: theme.transitions.easing.easeOut,
                                    duration: 50, // Shortened from ~225ms to 50ms to prevent ResizeObserver loops
                                }),
                                [theme.breakpoints.up('md')]: {
                                    marginLeft: !isAuthenticated ? 0 : isAuthenticated && open ? "240px" : isAuthenticated && "72px",
                                },
                                // Override margins when QPilot is full screen on mobile
                                ...(isMobile && showQPilotChat && {
                                    marginLeft: '0px !important',
                                    marginRight: '0px !important'
                                })
                            }}
                        >
                            {/* Navigation Update Banner - Only show when new navigation is active */}
                            {isAuthenticated && getNavigationVersion(currUser) && (
                                <Box sx={{ px: 3, pt: 2 }}>
                                    <NavigationUpdateBanner />
                                </Box>
                            )}

                            <Grid container justifyContent="center" spacing={0}>
                                <Grid
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                    xl
                                >
                                    {upcomingMaintenance && Object.keys(upcomingMaintenance).length > 0 && upcomingMaintenance['scheduled_maintenances']
                                        && upcomingMaintenance['scheduled_maintenances'].length > 0 &&
                                        parseJSON(upcomingMaintenance["scheduled_maintenances"][0]['scheduled_for']) > new Date() &&
                                        parseJSON(upcomingMaintenance["scheduled_maintenances"][0]['scheduled_until']) < new Date() &&
                                        <Grid item xs={12}>
                                            <Accordion elevation={1} square>
                                                <AccordionSummary>
                                                    {upcomingMaintenance && Object.keys(upcomingMaintenance)
                                                        && upcomingMaintenance['scheduled_maintenances'] &&
                                                        <React.Fragment><MdInfo color={"#579FEE"}
                                                            size={18} />&nbsp;&nbsp;<Typography
                                                                variant="h4">Scheduled maintenance in progress (click
                                                                for
                                                                details)</Typography>
                                                        </React.Fragment>
                                                    }
                                                </AccordionSummary>
                                                {upcomingMaintenance && Object.keys(upcomingMaintenance).length > 0 && upcomingMaintenance['scheduled_maintenances']
                                                    && upcomingMaintenance['scheduled_maintenances'].length > 0 &&
                                                    parseJSON(upcomingMaintenance["scheduled_maintenances"][0]['scheduled_for']) > new Date() &&
                                                    <AccordionDetails>
                                                        Maintenance scheduled
                                                        for {format(parseJSON(upcomingMaintenance["scheduled_maintenances"][0]['scheduled_for']), "MMM d, yyyy hh:mm aaaaa'm'")} - {format(parseJSON(upcomingMaintenance["scheduled_maintenances"][0]['scheduled_until']), "MMM d, yyyy hh:mm aaaaa'm'")}.
                                                        View status details and history on our <Link target="_blank"
                                                            href={"https://status.qflow.ai"}>status
                                                            page</Link>.
                                                    </AccordionDetails>
                                                }
                                            </Accordion>
                                        </Grid>
                                    }

                                    <Grid item xs={12}>
                                        <Routes
                                        />

                                        {trialAlertOpen &&
                                            <TrialReminderSnackbar
                                                alertOpen={trialAlertOpen}
                                                handleTrialAlertClose={handleTrialAlertClose}
                                            />
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                        {isAuthenticated &&
                            <QPilotChatbot
                                qPilotDrawerWidth={qPilotDrawerWidth}
                                isMobile={isMobile}
                                handleShowQPilotChatChange={handleShowQPilotChatChange}
                                showQPilotChat={showQPilotChat}
                                currUser={currUser}
                                isFocusMode={isQpilotFocus}
                                onToggleFocus={toggleQpilotFocus}
                                initialQuestion={qPilotInitialQuestion}
                                clearInitialQuestion={() => setQPilotInitialQuestion("")}
                            />
                        }
                        {!isAuthenticated && !isAuthenticating &&
                            <UnauthenticatedFooter />
                        }

                        {!isAuthenticated && !isAuthenticating &&
                            <CookieConsent
                                location="bottom"
                                buttonText="Accept Cookies"
                                cookieName="qflow_cookie_consent"
                                style={{
                                    background: "#FFF",
                                    color: "#272931",
                                    paddingLeft: "15%",
                                    justifyContent: "flex-start"
                                }}
                                enableDeclineButton
                                declineButtonStyle={{
                                    backgroundColor: "#fff",
                                    color: "#272931",
                                    border: "1px #272931 solid",
                                    fontSize: "13px",
                                    borderRadius: "4px"
                                }}
                                declineButtonText={"Do Not Sell My Personal Information"}
                                contentStyle={{ maxWidth: 550 }}
                                buttonStyle={{
                                    backgroundColor: "#272931",
                                    color: "#FFF",
                                    fontSize: "13px",
                                    borderRadius: "4px"
                                }}
                                expires={150}
                            >
                                This website uses cookies to enhance user experience and to analyze performance and
                                traffic.
                                {" "}
                            </CookieConsent>
                        }

                        </AppContext.Provider>
                        </DownloadSnackbarProvider>
                    </RateLimitProvider>

            
                </Box>
            </Elements>
            :
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', gap: 2 }}>
                <CircularProgress size={48} />
                <Typography variant="body2" color="text.secondary">
                    {isLoggingOut ? 'Signing out...' : 'Loading...'}
                </Typography>
                <ColdStartShortcutHint
                    visible={hasStoredSession && !isLoggingOut && !isMobile}
                />
            </Box>
            }
        </React.Fragment>
    )
}
export default App;
